<template>
    <div>
        <hr class="mg-t-10 mg-b-30">
        <div class="row">
            <div class="col-sm-6 col-lg-3">
                <div class="card card-help">
                    <div class="card-body tx-13">
                        <div class="tx-60 lh-0 mg-b-25"><i class="icon ion-ios-briefcase"></i></div>
                        <h5><router-link to="/account" class="link-01">Account Services</router-link></h5>
                        <p class="tx-color-03 mg-b-0">Service Rules, Mandates </p>
                        <p class="tx-color-03 mg-b-0">Account Opening, Account Views,</p>
                        <p class="tx-color-03 mg-b-0"> Authorization Queues, Activity Report</p>

                    </div><!-- card-body -->
                    <div class="card-footer tx-13">
                        <span>View Details</span>
                        <router-link to="/account" class="tx-18 lh-0"><i class="icon ion-md-arrow-forward"></i></router-link>
                    </div><!-- card-footer -->
                </div><!-- card -->
            </div><!-- col -->
            <div class="col-sm-6 col-lg-3 mg-t-20 mg-sm-t-0">
                <div class="card card-help">
                    <div class="card-body tx-13">
                        <div class="tx-60 lh-0 mg-b-25"><i class="icon ion-ios-card"></i></div>
                        <h5><router-link to="/payments/funds-transfer-multiple" class="link-01">Payments</router-link></h5>
                        <p class="tx-color-03 mg-b-0">Payment ecosystem</p>
                        <p class="tx-color-03 mg-b-0">Funds Transfer, Bills Payment</p>
                        <p class="tx-color-03 mg-b-0">Standing Instructions, Direct Debit..</p>

                    </div><!-- card-body -->
                    <div class="card-footer tx-13">
                        <span>View Details</span>
                        <router-link to="/payments/funds-transfer-multiple" class="tx-18 lh-0"><i class="icon ion-md-arrow-forward"></i></router-link>
                    </div><!-- card-footer -->
                </div><!-- card -->
            </div><!-- col -->
            <div class="col-sm-6 col-lg-3 mg-t-20 mg-sm-t-30 mg-lg-t-0">
                <div class="card card-help">
                    <div class="card-body tx-13">
                        <div class="tx-60 lh-0 mg-b-25"><i class="icon ion-ios-cash"></i></div>
                        <h5><a href="#" class="link-01">Liquidity</a></h5>
                        <p class="tx-color-03 mg-b-0">Cash Management</p>
                        <p class="tx-color-03 mg-b-0">Loans, Pooling, Fixed Deposit</p>
                        <p class="tx-color-03 mg-b-0">Treasury Bills, Sweeps, FX-Bids </p>


                    </div><!-- card-body -->
                    <div class="card-footer tx-13">
                        <span class="tx-center"><a href="#" class=" badge block badge-danger">Coming Soon</a></span>

                    </div><!-- card-footer -->
                </div><!-- card -->
            </div><!-- col -->
            <div class="col-sm-6 col-lg-3 mg-t-20 mg-sm-t-30 mg-lg-t-0">
                <div class="card card-help">
                    <div class="card-body tx-13">
                        <div class="tx-60 lh-0 mg-b-25"><i class="icon ion-ios-basket"></i></div>
                        <h5><a href="#" class="link-01">Collections</a></h5>
                        <p class="tx-color-03 mg-b-0">Collection Services</p>
                        <p class="tx-color-03 mg-b-0">Sales Management, Invoicing</p>
                        <p class="tx-color-03 mg-b-0">Direct Debit, Account Receivable </p>


                    </div><!-- card-body -->
                    <div class="card-footer tx-13">
                        <span class="tx-center"><a href="#" class=" badge block badge-danger">Coming Soon</a></span>

                    </div><!-- card-footer -->
                </div><!-- card -->
            </div><!-- col -->
        </div><!-- row -->
        <hr class="mg-t-30 mg-b-30">
        <div class="row">
            <div class="col-sm-6 col-lg-3">
                <div class="card card-help">
                    <div class="card-body tx-13">
                        <div class="tx-60 lh-0 mg-b-25"><i class="icon ion-md-git-branch"></i></div>
                        <h5><a href="/merchants/" class="link-01">Merchant Services</a></h5>
                        <p class="tx-color-03 mg-b-0">Factoring</p>
                        <p class="tx-color-03 mg-b-0">Supplier Management </p>
                        <p class="tx-color-03 mg-b-0">Invoicing, Account Receivable</p>


                    </div><!-- card-body -->
                    <div class="card-footer tx-13">
                        <span class="tx-center"><a href="#" class=" badge block badge-danger">Coming Soon</a></span>

                    </div><!-- card-footer -->
                </div><!-- card -->
            </div><!-- col -->
            <div class="col-sm-6 col-lg-3 mg-t-20 mg-sm-t-0">
                <div class="card card-help">
                    <div class="card-body tx-13">
                        <div class="tx-60 lh-0 mg-b-25"><i class="icon ion-ios-folder-open"></i></div>
                        <h5><a href="#" class="link-01">ERP</a>
                        </h5>
                        <p class="tx-color-03 mg-b-0">Sales, Payroll, Inventory,</p>
                        <p class="tx-color-03 mg-b-0">User, Accounting, Expense &amp; </p>
                        <p class="tx-color-03 mg-b-0">Purchase Management, Fixed Assets</p>
                    </div><!-- card-body -->
                    <div class="card-footer tx-13">
                        <span class="tx-center"><a href="#" class=" badge block badge-danger">Coming Soon</a></span>
                    </div><!-- card-footer -->
                </div><!-- card -->
            </div><!-- col -->
            <div class="col-sm-6 col-lg-3 mg-t-20 mg-sm-t-30 mg-lg-t-0">
                <div class="card card-help">
                    <div class="card-body tx-13">
                        <div class="tx-60 lh-0 mg-b-25"><i class="icon ion-ios-document"></i></div>
                        <h5><a href="#" class="link-01">H2H Management</a></h5>
                        <p class="tx-color-03 mg-b-0">Customers, Invoicing</p>
                        <p class="tx-color-03 mg-b-0">Direct Debit, Billers Database</p>
                        <p class="tx-color-03 mg-b-0">Bills Payment, Order &amp; Product Mgt</p>

                    </div><!-- card-body -->
                    <div class="card-footer tx-13">
                        <span class="tx-center"><a href="#" class=" badge block badge-danger">Coming Soon</a></span>

                    </div><!-- card-footer -->
                </div><!-- card -->
            </div><!-- col -->
            <div class="col-sm-6 col-lg-3 mg-t-20 mg-sm-t-30 mg-lg-t-0">
                <div class="card card-help">
                    <div class="card-body tx-13">
                        <div class="tx-60 lh-0 mg-b-25"><i class="icon ion-ios-pie"></i></div>
                        <h5><a href="#" class="link-01">Dashboards</a></h5>
                        <p class="tx-color-03 mg-b-0">Dashboard & Analytics</p>
                        <p class="tx-color-03 mg-b-0">Events, Transactions, Messaging</p>
                        <p class="tx-color-03 mg-b-0">Alerts, Exchange Rate, User Activity</p>

                    </div><!-- card-body -->
                    <div class="card-footer tx-13">
                        <span class="tx-center"><a href="#" class=" badge block badge-danger">Coming Soon</a></span>

                    </div><!-- card-footer -->
                </div><!-- card -->
            </div><!-- col -->
        </div><!-- row -->
      <hr>
<!--      <div class="row" v-if="this.auth.response.roles.includes('ADMIN', 0)">-->
<!--        <div class="col-sm-6 col-lg-3">-->
<!--          <div class="card card-help">-->
<!--            <div class="card-body tx-13">-->
<!--              <div class="tx-60 lh-0 mg-b-25"><i class="icon ion-md-git-branch"></i></div>-->
<!--              <h5><a href="/admin/stats" class="link-01">Admin Module</a></h5>-->
<!--              <p class="tx-color-03 mg-b-0">Number of companies</p>-->
<!--              <p class="tx-color-03 mg-b-0">Number of profiles, Transactions</p>-->
<!--              <p class="tx-color-03 mg-b-0">Active profiles, Outflow, Inflow </p>-->


<!--            </div>&lt;!&ndash; card-body &ndash;&gt;-->
<!--            <div class="card-footer tx-13">-->
<!--                <span>View Details</span>-->
<!--                <router-link to="/admin/stats" class="tx-18 lh-0"><i class="icon ion-md-arrow-forward"></i></router-link>-->
<!--            </div>&lt;!&ndash; card-footer &ndash;&gt;-->
<!--          </div>&lt;!&ndash; card &ndash;&gt;-->
<!--        </div>&lt;!&ndash; col &ndash;&gt;-->
<!--      </div>-->


    </div>
</template>

<script>
import { mapState} from "vuex"
// import FlotChart from "../FlotChart";
export default {
  name: "TopCards",
  computed:{
    ...mapState(['auth'])
  },
  components: {}
};
</script>

<style scoped>
p {
  font-size: smaller !important;
}
@media only screen and (min-width: 900px) {
  .top-card {
    width: 103%;
  }
}
@media only screen and (min-width: 707px) and (max-width: 900px) {
  .top-card {
    width: 104%;
  }
}

@media only screen and (min-width: 517px) and (max-width: 707px) {
  .top-card {
    width: 105%;
  }
}

@media only screen and (min-width: 451px) and (max-width: 517px) {
  .top-card {
    width: 106%;
  }
}

@media only screen and (max-width: 451px) {
  .top-card {
    width: 107%;
  }
}
</style>
